import { formatNumber } from "@kvix/shared";
import { Avatar, makeStyles } from "@material-ui/core";
import classNames from "classnames";
import React from "react";
import { Text } from "../../../Primitives";
const size = 24;
const border = 2;
const avatarSize = size + border;
const useStyles = makeStyles((theme) => ({
    root: {
        position: "relative",
        display: "flex",
        alignItems: "center"
    },
    totalUsersIndicator: {
        width: "auto",
        minWidth: "26px",
        paddingLeft: "4px",
        paddingRight: "4px",
        heigth: "26px",
        borderRadius: "13px",
        height: avatarSize,
        color: theme.palette.common.white,
        backgroundColor: theme.palette.secondary.dark,
        fontSize: 12,
        fontWeight: 700,
        lineHeight: avatarSize,
        marginLeft: -18,
        transform: "translateX(10px)",
        [theme.breakpoints.down("xs")]: {
            marginLeft: -20,
            transform: "translateX(10px)"
        }
    },
    user: {
        width: avatarSize,
        height: avatarSize,
        marginRight: 8
    },
    userCollapsed: {
        "&:first-child": {
            marginLeft: -10,
            transform: "translateX(10px)"
        },
        [theme.breakpoints.down("xs")]: {
            marginLeft: -20,
            transform: "translateX(10px)"
        },
        marginLeft: -18,
        transform: "translateX(10px)"
    },
    text: {
        opacity: 0.75,
        marginLeft: theme.spacing(1),
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
    }
}));
const MAX_VISIBLE_AVATARS = 7;
const COLLAPSE_TRESCHOLD = 5;
const getAvatarUrl = (user) => {
    if (typeof user === "string") {
        return user;
    }
    return user === null || user === void 0 ? void 0 : user.imageUrl;
};
export const UserAvatarListCards = (props) => {
    const classes = useStyles(props);
    const { users, noOfVisible = MAX_VISIBLE_AVATARS } = props;
    if (!users) {
        return null;
    }
    const selectedUsers = users.slice(0, noOfVisible);
    const usersCount = props.total || users.length;
    function stringToColor(string) {
        let hash = 0;
        let i;
        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }
        let color = '#';
        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */
        return color;
    }
    function stringAvatar(name) {
        return {
            style: {
                backgroundColor: stringToColor(name),
                fontSize: '13px',
            },
            children: `${name.split(' ')[0][0]}`,
        };
    }
    return (React.createElement("div", { className: classes.root },
        selectedUsers.map((user, index) => {
            var _a, _b, _c, _d;
            const defaultAvatar = (_a = user === null || user === void 0 ? void 0 : user.imageUrl) === null || _a === void 0 ? void 0 : _a.includes('default-avatar');
            const showAvatarText = defaultAvatar && ((_b = user === null || user === void 0 ? void 0 : user.name) === null || _b === void 0 ? void 0 : _b.first);
            const avatarClasses = classNames({
                [classes.user]: true,
                [classes.userCollapsed]: true
            });
            if ((user === null || user === void 0 ? void 0 : user.imageUrl) && ((_c = user === null || user === void 0 ? void 0 : user.name) === null || _c === void 0 ? void 0 : _c.first)) {
                if (showAvatarText) {
                    return (React.createElement(Avatar, Object.assign({ key: `${index}-${user}`, className: avatarClasses, imgProps: { loading: "lazy" } }, stringAvatar(`${(_d = user === null || user === void 0 ? void 0 : user.name) === null || _d === void 0 ? void 0 : _d.first.toUpperCase()}`))));
                }
                else {
                    return (React.createElement(Avatar, { key: `${index}-${user}`, className: avatarClasses, src: getAvatarUrl(user), imgProps: { loading: "lazy" } }));
                }
            }
            else {
                return (React.createElement(Avatar, { key: `${index}-${user}`, className: avatarClasses, src: getAvatarUrl('https://cdn.kvix.tv/assets/kvix-default-avatar.svg'), imgProps: { loading: "lazy" } }));
            }
        }),
        usersCount <= COLLAPSE_TRESCHOLD && usersCount > 0 && props.text && (React.createElement(Text, { className: classes.text }, props.text(usersCount))),
        usersCount > COLLAPSE_TRESCHOLD && (React.createElement(Avatar, { className: `${classes.totalUsersIndicator} ${classes.border}`, imgProps: {
                loading: "lazy"
            } }, formatNumber(usersCount))),
        usersCount === 0 && props.empty && React.createElement(Text, { className: classes.text }, props.empty)));
};
//# sourceMappingURL=index.js.map